export function getEventImage(event, page, pageImage = null) {

  if (event.venue?.coverImage && (page === 'composer' || page === 'performer')) {
    return event.venue.coverImage
  }
  // 1. Check main event image - always show if available
  if (event?.image) {
    return event.image;
  }

  // 2. Check composers for image first (except on composer pages)
  // Skip composer images on composer pages to avoid repetition
  if (Array.isArray(event?.composers) && page !== "composer") {
    for (const composer of event.composers) {
      if (composer.image) {
        return composer.image;
      }
    }
  }

  // 3. Check cast for famousPerformer.image
  // Skip performer images on performer pages to avoid repetition
  if (Array.isArray(event?.cast) && page !== "performer") {
    for (const member of event.cast) {
      if (member.famousPerformer?.image) {
        return member.famousPerformer.image;
      }
    }
  }

  // 4. Check venue.operaImage
  // Skip venue images on opera house pages to avoid repetition
  if (event.venue?.operaImage && page !== "operahouse") {
    return event.venue.operaImage;
  }

  // 5. Check venue.venueImage
  // Skip venue images on opera house pages to avoid repetition
  if (event.venue?.venueImage && page !== "operahouse") {
    return event.venue.venueImage;
  }

  // 6. Last resort: Use the page's own image if provided
  if (pageImage) {
    return pageImage;
  }

  // 7. No image found - return null for empty image
  return null;
}
